export default [
  {
    id: 1,
    DayMonYear: 'Fri, Jan 10, 2025',
    memberAvatar: "",
    memberName: "Ava Smith", // Member Name
    memberRole: "Social Media Strategist", // Member Role
    status: "Free", 
    
  },
   {
    id: 2,
    DayMonYear: 'Fri, Jan 11, 2025',
    memberAvatar: "https://i.pravatar.cc/150?img=3",
    memberName: "Devon Lane", // Member Name
    memberRole: "Social Media Strategist", // Member Role
    status: "Starter", 
   
  },
   
];
